export type PlansTableMessages = {
  productColumn: string;
  planColumn: string;
  contractDateColumn: string;
  endDateColumn: string;
  renewalDateColumn: string;
  pricePerEventColumn: string;
  eventsIncludedMonthlyFeeColumn: string;
  feePerSalesConversionColumn: string;
  fixedFeePerSalesConvertionColumn: string;
  fixedMonthlyFeeColumn: string;
  statusColumn: string;
  optionsColumn: string;

  // Popover messages
  newPlanButton: string;
  cancelButton: string;

  // Update messages
  planUpdateSuccess: string;
  planUpdateError: string;

  //Dialog messages
  confirmCancelDialogTitle: string;
  confirmCancelDialogDescription: string;

  //Plan status messages
  activeStatusMessage: string;
  inactiveStatusMessage: string;
  holdStatusMessage: string;
  cancelledStatusMessage: string;

  integralFeeTypeLabel: string;
  minimumConsumptionFeeTypeLabel: string;

  transactionReceiptUrl: string;
  cancellationReceiptTitle: string;
};

export const PLANS_TABLE_MESSAGES: PlansTableMessages = {
  productColumn: "Nome do Produto",
  planColumn: "Nome do Plano",
  contractDateColumn: "Data de Contratação",
  endDateColumn: "Data de Encerramento",
  renewalDateColumn: "Próximo reajuste de preço",
  pricePerEventColumn: "Preço por Evento",
  eventsIncludedMonthlyFeeColumn: "Eventos Mensais",
  feePerSalesConversionColumn: "% por Venda",
  fixedFeePerSalesConvertionColumn: "R$ por Venda",
  fixedMonthlyFeeColumn: "Valor Mensal",
  statusColumn: "Status",
  optionsColumn: "Opções",

  // Popover messages
  newPlanButton: "Novo Plano",
  cancelButton: "Cancelar",

  // Update messages
  planUpdateSuccess: "Plano atualizado com sucesso",
  planUpdateError: "Erro ao atualizar o plano",

  //Dialog messages
  confirmCancelDialogTitle: "Confirmar Cancelamento",
  confirmCancelDialogDescription: "Você tem certeza que deseja cancelar este plano?",

  //Plan status messages
  activeStatusMessage: "Ativo",
  inactiveStatusMessage: "Inativo",
  holdStatusMessage: "Aguardando pagamento",
  cancelledStatusMessage: "Cancelado",

  integralFeeTypeLabel: "Integral",
  minimumConsumptionFeeTypeLabel: "Consumo mínimo",

  transactionReceiptUrl: "Comprovante de Pagamento",
  cancellationReceiptTitle: "Comprovante de Cancelamento",
};

export default PLANS_TABLE_MESSAGES;
